<template>
<span id="credit-and-re-bill" v-if="isVisible()">
  <el-button id="btn-credit-and-re-bill" type="success" plain @click="openDialog()" size="mini">{{ $t('invoices.creditAndReBill.title') }}</el-button>
  <el-dialog
    :close-on-click-modal="false"
    :title="$t('invoices.creditAndReBill.title')"
    :visible.sync="dialogVisible"
    width="34%"
    append-to-body
    id="credit-and-re-bill-dialog">
      <el-row>
        <span class="span-small-list"> {{ $t('invoices.creditAndReBill.followingCreditWillBeCreated') }} </span>
        <br>
        <span class="span-small-list">
          <strong>{{ $t('invoices.creditAndReBill.originalInvoiceNumber') }}</strong> {{ this.invoiceNumber }}
        </span>
        <span class="span-small-list">
          <strong>{{ $t('invoices.creditAndReBill.billTo') }}</strong> {{ this.billTo }}
        </span>
        <span class="span-small-list">
          <strong>{{ $t('invoices.creditAndReBill.date') }}</strong> {{ new Date() | moment(dateDisplayFormat)}}
        </span>
        <span class="span-small-list">
          <strong>{{ $t('invoices.creditAndReBill.amount') }}</strong> ({{ this.totalAmount | currency }}) <br>
        </span>
        <br>
        <span class="span-small-list">
          <strong> {{ this.totalShipments }} </strong> {{ $t('invoices.creditAndReBill.shipmentsWillBeOpened') }}<br> {{ $t('invoices.creditAndReBill.doYouWishContinue') }}
        </span>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="creditAndReBill" size="mini" class="margin-r-18">{{ $t('invoices.creditAndReBill.title') }}</el-button>
      </div>
  </el-dialog>
</span>
</template>

<script>
import constants from '@/utils/constants';
import { INVOICES_CREATE_CREDIT, SHIPMENT_GET_TOTAL_BY_INVOICE_ID } from '@/store/actions';

export default {
  name: 'CreditAndReBill',
  props: {
    invoiceId: {
      type: Number,
      default: null
    },
    invoiceNumber: {
      type: String,
      default: null
    },
    billTo: {
      type: String,
      default: null
    },
    invoiceDate: {
      type: String,
      default: null
    },
    totalAmount: {
      type: Number,
      default: null
    },
    credited: {
      type: Boolean,
      default: null
    },
    posted: {
      type: Boolean,
      default: null
    },
    parentInvoiceNumber: {
      type: String,
      default: null
    },
    successHandler: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      totalShipments: null,
      dateDisplayFormat: constants.DATES.DEFAULT_DISPLAY_FORMAT
    };
  },
  methods: {
    isVisible() {
      return this.posted && !this.credited && !this.parentInvoiceNumber && this.$can(this.permissions.BILLING.REBILL_INVOICE);
    },
    async openDialog() {
      // Get total shipments
      const totalShipmentsResponse = await this.$store.dispatch(SHIPMENT_GET_TOTAL_BY_INVOICE_ID, this.invoiceId).catch(() => {});
      this.totalShipments = totalShipmentsResponse.data;

      if (!this.totalShipments) {
        return;
      }

      this.dialogVisible = true;
    },
    async creditAndReBill() {
      const loading = this.$loading(constants.LOADING.CREDIT_AND_REBILL);
      try {
        const response = await this.$store.dispatch(INVOICES_CREATE_CREDIT, this.invoiceId).catch(() => {});
        this.$message.success(response.message);
        this.dialogVisible = false;
        this.successHandler();
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#credit-and-re-bill {
  float: right;
}
</style>
